module.exports = __webpack_public_path__ + "img/code_icon.a1b711b2.png";